import React from 'react'

export default function ProfitHistoryPage() {
  return (
    <div>
      wefewfew
    </div>
  )
}
